
import React from 'react';
import { Button } from '@/components/ui/button';
import { Switch } from '@/components/ui/switch';
import { Badge } from '@/components/ui/badge';
import { Eye, EyeOff, Copy } from 'lucide-react';

interface ApiKeyItemProps {
  name: string;
  createdDate: string;
  apiKey: string;
  keyType: string;
  editing: boolean;
  showApiKey: boolean;
  onToggleVisibility: () => void;
  onCopyApiKey: () => void;
}

const ApiKeyItem: React.FC<ApiKeyItemProps> = ({
  name,
  createdDate,
  apiKey,
  keyType,
  editing,
  showApiKey,
  onToggleVisibility,
  onCopyApiKey
}) => {
  return (
    <div className="border rounded-md p-4">
      <div className="flex justify-between items-start mb-2">
        <div>
          <div className="flex items-center gap-2">
            <h4 className="font-medium">{name}</h4>
            <Badge className="bg-green-100 text-green-800 hover:bg-green-100 text-xs">{keyType}</Badge>
          </div>
          <p className="text-sm text-muted-foreground">Created on {createdDate}</p>
        </div>
        {editing && (
          <Switch 
            checked={true} 
            disabled={!editing}
          />
        )}
      </div>
      
      <div className="mt-3 p-2 bg-muted rounded-md flex items-center justify-between">
        <code className="text-sm font-mono">
          {showApiKey ? apiKey : apiKey.replace(/(?<=^.{8}).*(?=.{0}$)/, "•".repeat(apiKey.length - 8))}
        </code>
        <div className="flex gap-1">
          <Button 
            variant="ghost" 
            size="sm" 
            className="h-8 w-8 p-0" 
            onClick={onToggleVisibility}
          >
            {showApiKey ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
          </Button>
          <Button 
            variant="ghost" 
            size="sm" 
            className="h-8 w-8 p-0"
            onClick={onCopyApiKey}
          >
            <Copy className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ApiKeyItem;
